import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "guideIndex"
};
const _hoisted_2 = {
  class: "view"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 0,
  class: "year"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_View = _resolveComponent("View");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_van_list = _resolveComponent("van-list");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_View)]),
    _: 1
  }), _createTextVNode(_toDisplayString($data.view), 1)]), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "imgtop"
  }, [_createElementVNode("img", {
    src: "https://p.ananas.chaoxing.com/star3/origin/341a1d40675956a8768a1290cbe92e5c.jpg",
    alt: ""
  })], -1)), _createVNode(_component_van_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $data.loading = $event),
    finished: $data.finished,
    "finished-text": $data.finishedtext,
    onLoad: $options.getList
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`${item.year ? 'yearList' : 'list'}`),
        key: item,
        onClick: $event => $options.toDetail(item)
      }, [item.year ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createTextVNode(_toDisplayString(item.year), 1), _cache[1] || (_cache[1] = _createElementVNode("span", null, "年", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
        src: item.image[0]
      }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)]))], 10, _hoisted_3);
    }), 128))]),
    _: 1
  }, 8, ["loading", "finished", "finished-text", "onLoad"])]);
}